module.exports = __webpack_public_path__ + "static/media/unsupport.08db2686.svg";